// FILE: localExecTemplatesClient.ts
// Purpose: Read the published local commands offered as starting points when declaring a new one.
// Layer: Web client
// Exports: `listLocalCommandTemplates`

import type { LocalCommandTemplate, ProjectId } from "@taskin-code/contracts";

import { adminFetch } from "./lib/adminFetch";

/**
 * The templates, already ordered by the server: the ones whose tags match this
 * project first, then alphabetically.
 *
 * Ordering server-side rather than here is deliberate. The judgement needs the
 * *target project's* tags, and reading those needs `p.edit` on it — a
 * permission somebody who merely curates its local commands may not hold. The
 * server knows both sides and needs no such grant to compare them.
 */
export async function listLocalCommandTemplates(
  projectId: ProjectId,
): Promise<ReadonlyArray<LocalCommandTemplate>> {
  const result = await adminFetch<{ templates: ReadonlyArray<LocalCommandTemplate> }>(
    `/api/local-command-templates?projectId=${encodeURIComponent(projectId)}`,
  );
  return result.templates;
}
